module.exports = __webpack_public_path__ + "img/angle-down-orange.7ea096f8.svg";